import classnames from 'classnames';
import T from 'prop-types';
import React, { Component } from 'react';

const NOOP = () => {};

export default class FileDropTarget extends Component {
  static propTypes = {
    children: T.node.isRequired,
    className: T.string,
    types: T.arrayOf(T.string),
    allow: T.arrayOf(T.string),
    onDragOver: T.func,
    onDragEnd: T.func,
    onDrop: T.func,
    onFileNotAllowed: T.func,
  };

  static defaultProps = {
    className: '',
    types: [],
    allow: [],
    onDragOver: NOOP,
    onDragEnd: NOOP,
    onDrop: NOOP,
    onFileNotAllowed: NOOP,
  };

  onDragOver = evt => {
    if (this.isValidType(evt.dataTransfer.types)) {
      evt.preventDefault();
      this.props.onDragOver();
    }
  };

  onDragEnd = evt => {
    if (this.isValidType(evt.dataTransfer.types)) {
      evt.preventDefault();
      this.props.onDragEnd();
    }
  };

  onDrop = evt => {
    if (this.isValidType(evt.dataTransfer.types)) {
      evt.preventDefault();
      const file = evt.dataTransfer.files[0];
      if (this.isTypeAllowed(file.type)) {
        this.props.onDrop(file);
      } else {
        this.props.onFileNotAllowed();
      }
    }
  };

  isValidType(types) {
    return this.props.types.filter(type => types.indexOf(type) > -1).length > 0;
  }

  isTypeAllowed(type) {
    return this.props.allow.indexOf(type) > -1;
  }

  render() {
    const { className } = this.props;

    return (
      <div
        className={classnames('file-drop-target', className)}
        onDragOver={this.onDragOver}
        onDragLeave={this.onDragEnd}
        onDragEnd={this.onDragEnd}
        onDrop={this.onDrop}
      >
        {this.props.children}
      </div>
    );
  }
}
